import React from 'react'

const FooterBottom = () => {
  return (
    <div className='w-full  text-center flex justify-center'>
      <p> Create With ❤️ By YUVRAJ RATHOD </p>
    </div>
  );
}

export default FooterBottom;